import { createSlice } from "@reduxjs/toolkit";
import { Tracking } from "./types";

interface TrackingState {
  data: {
    dataHome: Tracking; // Replace 'any' with a more specific type if possible
  };
}

const TrackingSlice = createSlice({
  name: 'Tracking',
  initialState: { data: { dataHome: {} } } as TrackingState,
  reducers: {
    setDataHome: (state, action) => {
      state.data.dataHome = action.payload;
    },
  },
});

export const { setDataHome } = TrackingSlice.actions;
export const TrackingReducer = TrackingSlice.reducer;